/**
 * SUPERKAWA — Canaux de contact (source de vérité légère).
 * MB-SUPPORT-MVP-2. Aucune logique métier, aucun backend.
 *
 *  - SUPPORT_EMAIL : assistance / aide produit.
 *  - CONTACT_EMAIL : contact commercial.
 */
export const SUPPORT_EMAIL = 'support@superkawa.co';
export const CONTACT_EMAIL = 'contact@superkawa.co';

export const supportMailto = `mailto:${SUPPORT_EMAIL}`;
export const contactMailto = `mailto:${CONTACT_EMAIL}`;
